import { PaymentData } from "@adyen/adyen-web";

export interface IPayment {
    address: IAddressViewModel;
    applePayData: PaymentData;
    cardData: PaymentData;
    isBillingAddressSameAsDelivery: boolean;
    cardHolderName: string;
    //cloudflareTurnstileResponse: string;
    giftCardNumber: string;
    giftCardVerificationCode: string;
    googlePayData: PaymentData;
    idempotencyKey: string;
    marketingRequest: IMarketingRequest;
    paymentTypeApplePaySelected: boolean;
    paymentTypeCardSelected: boolean;
    paymentTypeGiftCardSelected: boolean;
    paymentTypeGooglePaySelected: boolean;
    paymentTypePayByBankSelected: boolean;
    paymentTypePayPalSelected: boolean;
    payByBankData: any;
}

interface IAddressViewModel {
    company: string;
    countryCodeIso3: string;
    county: string;
    district: string;
    editorVisible: boolean;
    line1: string;
    line2: string;
    postalCode: string;
    stateRequired: boolean;
    town: string;
}

export interface IMarketingRequest {
    requestEmail: PreferenceAnswer;
    requestPost: PreferenceAnswer;
    requestThirdParty: PreferenceAnswer;
}

export enum PreferenceAnswer {
    NotAnswered = "NotAnswered",
    Restricted = "Restricted",
    Allowed = "Allowed",
}
